import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "actions"]

  connect() {
    this._checkScroll()
    if (this.hasContentTarget) {
      this.contentTarget.addEventListener("scroll", () => this._checkScroll())
    }
  }

  _checkScroll() {
    if (!this.hasContentTarget || !this.hasActionsTarget) return
    const el = this.contentTarget
    const hasOverflow = el.scrollHeight > el.clientHeight
    const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 5

    if (hasOverflow && !isAtBottom) {
      this.actionsTarget.classList.add("has-shadow")
    } else {
      this.actionsTarget.classList.remove("has-shadow")
    }
  }
}
